import PropTypes from 'prop-types';
import RCColorPicker from 'rc-color-picker';
import React from 'react';
import './styles.scss';

class ColorPicker extends React.Component {
  static propTypes = {
    color: PropTypes.string.isRequired,
    resetValue: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      color: props.color,
    };
  }

  handleChange = (newColor) => {
    this.setState({color: newColor.color});
    this.props.onChange(newColor.color);
  }

  handleClearColor = () => this.handleChange({color: this.props.resetValue});

  render() {
    return (
      <div className="color-picker-component">
        <div className="clear-color" onClick={this.handleClearColor}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 10" preserveAspectRatio="none">
            <line x1="1" y1="9"
                  x2="9" y2="1"
                  stroke="black" strokeWidth={1}/>
          </svg>
        </div>
        <RCColorPicker color={this.state.color} onChange={this.handleChange}/>
      </div>
    );
  }
}

export default ColorPicker;



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/widgets/ColorPicker/index.js